/**
 * Created by fers on 22/11/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {getMessageArgsForDataSource} from '../view/screen-settings/DataSourceList.react';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import Link from 'react-router/lib/Link';

class ScenarioDataSourceList extends React.Component {
    static propTypes = {
        channelDefMap: PropTypes.object.isRequired,
        dataSources: PropTypes.array.isRequired,
        describeSelectionRules: PropTypes.bool,
        destinationChannelDef: PropTypes.object,
        intl: PropTypes.object,
        screen: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    renderDataSource(dataSource, idx) {
        let screen = this.props.screen;

        let parentIdx = -1;
        let parentDataSource = null;
        if (dataSource.relativeTo_id) {
            parentIdx = screen.dataSources.findIndex((dataSource2) => dataSource2['realId'] === dataSource.relativeTo_id);
            if (parentIdx !== -1) {
                parentDataSource = screen.dataSources[parentIdx];
            }
        }

        let title = "";
        let entityDef = "";
        let description = "";

        if (dataSource.channelDefKeys) {
            dataSource.channelDefs = dataSource.channelDefKeys.map((channelDefKey) => this.props.channelDefMap[channelDefKey]).filter((a) => a ? true : false);
        }

        let messageArgs = getMessageArgsForDataSource(dataSource, parentDataSource);

        if (dataSource.entityDefs && dataSource.entityDefs.length > 0) {
            entityDef += dataSource.entityDefs.map((ed) => ed.name).join(", ");
        }

        if (dataSource.description) {
            description += dataSource.description;
        } else {
            description += this.props.intl.formatMessage({
                id: 'dataSource.' + dataSource.typeId + '.description',
            }, messageArgs);
        }

        if (dataSource.name) {
            title += dataSource.name;
        } else {
            title += this.props.intl.formatMessage({
                id: 'dataSource.' + dataSource.typeId + '.name',
            }, messageArgs);
        }

        if (!title) {
            title = entityDef;
            entityDef = "";
        }

        let parent;
        if (parentIdx !== -1) {
            parent = screen.dataSources[parentIdx];

            if (parent.idx) {
                //display stored idx not order from datasources
                parentIdx = parent.idx;
            }
            else {
                parentIdx += 1;
            }
        }

        return (
            <div className={"dataSource-box noBoxesToAdd"} key={idx}>
                <div className="dataSource-item">
                    <div className="dataSource-idx-box"><span className="dataSource-idx" title={description}>#{dataSource.idx || idx + 1}</span></div>
                    <div className="dataSource-title-icon">
                        {dataSource.channelDefs && dataSource.channelDefs.length > 0 ? dataSource.channelDefs.map((channelDef, idx) => channelDef.icon ? <ChannelIcon channelDef={channelDef} key={idx} size={32} /> : null) : <ChannelIcon channelDef={{icon: 'dativery'}} size={32} />}
                   </div>
                    <div className="dataSource-title-box">
                        <strong>{title}</strong> {parent ?
                            <span className="dataSource-relativeTo-description"><FormattedMessage defaultMessage="Uses data from" id="screenSettings.dependsOn" />{" "}
                                <span className="dataSource-idx" title={parent.name ? parent.name : (parent.entityDefs.map((ed) => ed.name).join(", "))}>#{parentIdx}</span>
                            </span>
                            : null
                        }
                        <br/>
                        {description ? <small>{description}</small> : (dataSource.type === 'default-query' ? <small><FormattedMessage defaultMessage="When you open {channelDef} and select {dataType}." id="screenSettings.defaultQueryDescription" values={{channelDef: this.props.destinationChannelDef.name, dataType: screen.entityDef.name}} /></small> : null)}
                        {this.props.describeSelectionRules && dataSource.entitySelectionRules ?
                            <small> (<FormattedMessage defaultMessage="Type:" id="scenarioDataSourceList.dataSourceType" /> <code>{dataSource.type}</code>) <ul>
                                {dataSource.entitySelectionRules.map((rule, idx) => {
                                    return (
                                        <li key={idx}>
                                            <Link className="btn btn-default btn-small" style={{float: 'right'}} to={urlMapping.getUrl(types['entitySelectionRules'], 'edit', {...rule, dataSource_id: dataSource.realId, scenarioScreenDef_id: screen.realId, scenarioDef_id: screen.scenarioDef_id})}><FormattedMessage defaultMessage="Edit" id="common.edit" /></Link>
                                            <ul>
                                                {rule.channelDefKey ? <li><FormattedMessage defaultMessage="Application Type Key:" id="scenarioDataSourceList.channelDefKey" /> <code>{rule.channelDefKey}</code></li> : null}
                                                {rule.channelDef ? <li><FormattedMessage defaultMessage="Application Type:" id="scenarioDataSourceList.channelDef" /> {rule.channelDef.name}</li> : null}
                                                {rule.entityDef ? <li><FormattedMessage defaultMessage="Entity Definition:" id="scenarioDataSourceList.entityDef" /> {rule.entityDef.name} {rule.entityDef.groupDef ? " (" + rule.entityDef.groupDef.name + ")" : null}</li> : null}
                                                {rule.sourceDef ? <li><FormattedMessage defaultMessage="Source Definition:" id="scenarioDataSourceList.sourceDef" /> {rule.sourceDef.name}</li> : null}
                                                {rule.channel_id ? <li><FormattedMessage defaultMessage="Application:" id="scenarioDataSourceList.channelId" /> <code>{rule.channel_id}</code></li> : null}
                                            </ul>
                                        </li>
                                    );
                                })}
                            </ul></small>
                            : null
                        }
                        {this.props.describeSelectionRules && dataSource.helperSelectionRules ?
                            <small> (<FormattedMessage defaultMessage="Type:" id="scenarioDataSourceList.dataSourceType" /> <code>{dataSource.type}</code>) <ul>
                            {dataSource.helperSelectionRules.map((rule, idx) => {
                                return (
                                    <li key={idx}>
                                        <Link className="btn btn-default btn-small" style={{float: 'right'}} to={urlMapping.getUrl(types['entitySelectionRules'], 'edit', {...rule, dataSource_id: dataSource.realId, scenarioScreenDef_id: screen.realId, scenarioDef_id: screen.scenarioDef_id})}><FormattedMessage defaultMessage="Edit" id="common.edit" /></Link>
                                        <ul>
                                            {rule.channelDefKey ? <li><FormattedMessage defaultMessage="Application Type Key:" id="scenarioDataSourceList.channelDefKey" /> <code>{rule.channelDefKey}</code></li> : null}
                                            {rule.channelDef ? <li><FormattedMessage defaultMessage="Application Type:" id="scenarioDataSourceList.channelDef" /> {rule.channelDef.name}</li> : null}
                                            {rule.entityDef ? <li><FormattedMessage defaultMessage="Entity Definition:" id="scenarioDataSourceList.entityDef" /> {rule.entityDef.name} {rule.entityDef.groupDef ? " (" + rule.entityDef.groupDef.name + ")" : null}</li> : null}
                                            {rule.sourceDef ? <li><FormattedMessage defaultMessage="Source Definition:" id="scenarioDataSourceList.sourceDef" /> {rule.sourceDef.name}</li> : null}
                                            {rule.channel_id ? <li><FormattedMessage defaultMessage="Application:" id="scenarioDataSourceList.channelId" /> <code>{rule.channel_id}</code></li> : null}
                                        </ul>
                                    </li>
                                );
                            })}
                            </ul></small>
                            : null
                        }
                    </div>
                </div>
            </div>
            );
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-8">
                    {this.props.dataSources.sort((a, b) => { return parseInt(a.idx, 10) > parseInt(b.idx, 10) ? 1 : (parseInt(a.idx, 10) < parseInt(b.idx, 10) ? -1 : 0); }).map((dataSource, idx) => {
                        return (
                            this.renderDataSource(dataSource, idx)
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default injectIntl(ScenarioDataSourceList);
